import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { semanticColors } from '../Globals/styles'

class PageSpinner extends Component {
  render () {
    const { style } = this.props;
    return (
      <div style={styles.spinnerContainer}>
        <div style={[styles.spinner, style && style]}> Indlæser...
            <div>
              <i className="fa fa-spinner fa-spin fa-3x"/>
            </div>
        </div>
      </div>
    );
  }
}

var styles = {
  spinnerContainer: {
    width:'100%',
    height: '100%',
    position: 'absolute',
    top: '0',
    left: '0'
  },
  spinner : {
    width:'100px',
    color: semanticColors.default,
    position: 'absolute',
    top:'50%',
    left: '50%',
    marginTop:'-50px',
    marginLeft: '-50px',
    fontSize: '20px',
    textAlign: 'center'
  }
}

  PageSpinner.propTypes = {
    style: PropTypes.object
  };

export default Radium(PageSpinner);



// WEBPACK FOOTER //
// ./src/App/Common/pageSpinner.jsx